<template>
  <v-container id="childrenSection" fluid>
    <v-row>
      <v-col md="12" cols="12">
        <v-card flat tile>
          <v-card-title>
            <v-row align="center">
              <v-col cols="12" md="6" class="d-flex justify-md-start justify-center">
                <div class="heading-h3">Your Children</div>
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-md-end justify-center" v-if="!showAddKidsSection">
                <v-btn :to="{ name: 'AddChild' }" color="secondary">Add a child</v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="text-center text-md-left">
            <p>
              These are your children’s accounts. Click your child’s name to view their quests/progress.
            </p>
          </v-card-subtitle>
          <!-- No Kid Section -->
          <v-card-text class="add-new-section" v-if="showAddKidsSection">
            <v-row align="center" justify="center">
              <v-col cols="12" md="12" class="text-center">
                <div class="body-heading-medium mb-2">Ready to add your child?</div>
                <div class="mb-2">
                  Click "Add a child" to create a new account for your child
                </div>
                <v-btn :to="{ name: 'AddChild' }" color="secondary">Add a child</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <!-- Kid List Section -->
          <v-item-group class="ma-4" v-else>
            <v-row>
              <v-col v-for="kid in kids" :key="kid.id" cols="12" md="12">
                <v-item>
                  <v-card class="d-flex align-center list-item" outlined hover :to="{ name: 'KidQuests', params: { id: kid.id } }">
                    <v-card-text class="py-0">
                      <v-row>
                        <v-col cols="12" md="1" class="d-flex justify-center align-center">
                          <v-avatar v-if="kid.avatar">
                            <img alt="Avatar" v-bind:src="kid.avatar" />
                          </v-avatar>
                          <v-avatar v-else color="grey lighten-2">
                            <v-icon>fa-user-circle</v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col cols="12" md="5" class="d-flex align-center justify-center justify-md-start">
                          <v-list-item two-line class="px-0">
                            <v-list-item-content class="text-center text-md-left">
                              <v-list-item-title class="body-heading-small mb-3">
                                {{ kid.name }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                <v-icon size="20" color="secondary" class="mr-1">fas fa-gem</v-icon>
                                <span class="body-heading-small">{{ kid.points }}</span>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end">
                          <v-btn text color="primary" :to="{ name: 'KidProfile', params: { id: kid.id } }">
                            Edit Profile
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-item-group>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  export default {
    name: "ChildrenSection",

    created() {
      this.$store.commit("setLoadingStatus", true);

      this.$http
        .get("/children")
        .then((response) => {
          this.$store.commit("setKids", response.data.children);
          this.$store.commit("setLoadingStatus", false);
        })
        .catch(() => {
          console.log("failed to retrieve children");
          this.$store.commit("setError", {
            message: this.$formatter.getErrorMsg(),
            type: "error",
          });
          this.$store.commit("setLoadingStatus", false);
        });
    },

    computed: {
      kids() {
        //Only return activated kid account
        return this.$store.getters.getKids.filter((kid) => kid.active === true);
      },

      showAddKidsSection() {
        if (this.kids.length > 0) {
          return false;
        }
        return true;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ParentDashboard/ChildrenSection.vue